import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Autocomplete, TextField, Button, Paper, Dialog, Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetListConsumerMutation, useGetListQRLocationMutation } from '../services/consumer';
import LoadingPage from './loadingPage';
import AlertSnackbar from './alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import { QRCodeSVG, QRCodeCanvas } from 'qrcode.react';

const API_URI = process.env.REACT_APP_API_URI;

export default function QRLocation() {
  const [getListQRLocation, listQRLocationResult] = useGetListQRLocationMutation();
  const [getData, dataResult] = useGetListConsumerMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [openOtp, setOpenOtp] = useState(false);
  const [qrSrc, setQrSrc] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState({});

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    getListQRLocation();
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
  }, []);

  useEffect(() => {
    if(listQRLocationResult && listQRLocationResult.data){
      const dt = JSON.parse(listQRLocationResult.data);
      setDataLoaded(dt);
      getCoumns(dt[0]);
    }
  }, [listQRLocationResult]);

  const getDataView=()=>{
    getListQRLocation();
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        resizable: true,
        hide: (key == 'CODE' ? true : false),
        cellStyle: () => ((key=="SaleQty")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="SuggestOrderWH" ? "bold" : ""
        }:null),
        width: (key == "LINK" ? 500 : 200),
        cellRenderer: (props) => (key == "LINK" ? CustomCell(props) : props.value)
      }
    });
    setCoumns(cols);
  }

  const CustomCell = (props) => {
    if(!props.data.CODE || props.data.CODE == '-1')
      return '';
    const handleClick = () => {
      setSelectedRecord(props.data);
      const encodedString = btoa(props.data.CODE);
      setOpenOtp(props.data.LINK + encodedString);
      setQrSrc(null);
    };
    const encodedString = btoa(props.data.CODE);
    return <Button onClick={handleClick}>{props.data.LINK}{encodedString}</Button>;
  };

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const downloadQRCode = () => {
    const qrCodeURL = document.getElementById('qrCodeEl')
      .toDataURL("image/png");
      //.replace("image/png", "image/octet-stream");
    setQrSrc(qrCodeURL);
    // let aEl = document.createElement("a");
    // aEl.href = qrCodeURL;
    // aEl.download = "QR_Code.png";
    // document.body.appendChild(aEl);
    // aEl.click();
    // document.body.removeChild(aEl);
  }

  return (
    <div style={{padding: '0 10px'}}>
      { (listQRLocationResult.isLoading || dataResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader'>
          <Button variant="contained" onClick={getDataView}
            sx={{ marginRight: '10px', marginBottom: '10px' }}>View</Button>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            getRowClass={getRowClass}
            theme={theme}
          />
        </Paper>
      </div>

      <Dialog onClose={()=>setOpenOtp(false)} open={openOtp} width={500} maxWidth={500}>
        <Button onClick={downloadQRCode}>Click To Load QR Code</Button>
        <Typography component="h1" variant="h6" sx={{textAlign: 'center'}}>
          {selectedRecord.LOCATION}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px', width: 500 }}>
          <div style={{display: 'none'}}>
            <QRCodeCanvas value={openOtp} size={2000} level='H' id="qrCodeEl"/>
          </div>
          <img src={qrSrc} width={500} height={500}></img>
        </Box>
        
      </Dialog>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}